import { render, staticRenderFns } from "./pos-header.vue?vue&type=template&id=f07e3598"
import script from "./pos-header.vue?vue&type=script&lang=js"
export * from "./pos-header.vue?vue&type=script&lang=js"
import style0 from "./pos-header.vue?vue&type=style&index=0&id=f07e3598&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports